<template><div><h1 id="wbs-infotext" tabindex="-1"><a class="header-anchor" href="#wbs-infotext"><span>WBS-Infotext</span></a></h1>
<p>WBS-Infotext — Definiert spezielle Texte für einzelne Aufträge</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit WBS-Infotext können einzelne Texte vordefiniert werden, die dann bei bei der Auftragserfassung gewählt und abgeändert werden können. Dieser Text erscheint dann auf der Rechnung, sofern dies im Layout des Rechnungsformulars vorgesehen ist.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → WBS-Infotextvorlagen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr</dt>
<dd>Nummer des WBS-Infotextes.</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung für den Infotext</dd>
<dt>Textfelder</dt>
<dd>Text, der auf dem WBS gedruckt wird.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


